import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./SerialNumber.css";
import Button from "react-bootstrap/Button";

const SerialNumber = () => {
  const [data, setData] = useState([]);
  const [record, setRecord] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showData, setShowData] = useState(false);
  const [userInputs, setUserInputs] = useState({});

  useEffect(() => {
    Axios.get(INVENTORY_API_BASE_URL + "/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  const handleClose = () => {
    setShowData(false);
  };

  const handleButtonClick = (item) => {
    setRecord(item.updatedQuantity);
    setSelectedOrderId(item.orderid);
    setShowData(true);
  };

  const handleUserInputChange = (e, orderId) => {
    const { value } = e.target;
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [orderId]: value,
    }));
  };

  const handleUpdateVehicle = (orderId) => {
    const updatedVehicle = userInputs[orderId];
    Axios.put(INVENTORY_API_BASE_URL + "/updateVehicle/" + orderId, {
      vehicle: updatedVehicle,
    })
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating vehicle:", error);
      });
  };

  const totalApprovedQuantity = data.reduce(
    (total, order) =>
      total +
      (order.updatedQuantity || []).reduce(
        (quantity, item) => quantity + (Number(item.approvedquantity) || 0),
        0,
      ),
    0,
  );

  const totalItems = data.reduce(
    (total, order) => total + (order.updatedQuantity || []).length,
    0,
  );

  return (
    <main className="serial-page">
      <div className="serial-workspace">
        <header className="serial-hero">
          <div className="serial-hero-copy">
            <p className="serial-eyebrow">Order operations / Serialization</p>
            <h1>Serial number register</h1>
            <p>
              Review approved order quantities, view batch serial numbers, and
              update vehicle details.
            </p>
          </div>
          <div className="serial-hero-badge">
            <span className="serial-hero-icon" aria-hidden="true">SN</span>
            <span className="serial-hero-badge-copy">
              <strong>Order serials</strong>
              <small>Approved quantity records</small>
            </span>
          </div>
        </header>

        <section className="serial-metrics" aria-label="Order summary">
          <article className="serial-metric">
            <span className="serial-metric-icon" aria-hidden="true">ORD</span>
            <span className="serial-metric-copy">
              <span>Orders</span>
              <strong>{data.length.toLocaleString("en-IN")}</strong>
            </span>
          </article>
          <article className="serial-metric serial-metric-quantity">
            <span className="serial-metric-icon" aria-hidden="true">QTY</span>
            <span className="serial-metric-copy">
              <span>Approved copies</span>
              <strong>{totalApprovedQuantity.toLocaleString("en-IN")}</strong>
            </span>
          </article>
          <article className="serial-metric serial-metric-items">
            <span className="serial-metric-icon" aria-hidden="true">SKU</span>
            <span className="serial-metric-copy">
              <span>Order line items</span>
              <strong>{totalItems.toLocaleString("en-IN")}</strong>
            </span>
          </article>
        </section>

        <section className="serial-panel" aria-labelledby="serial-register-title">
          <header className="serial-panel-heading">
            <div>
              <p className="serial-section-eyebrow">Order register</p>
              <h2 id="serial-register-title">Approved orders</h2>
              <p>View serials by batch or update the vehicle assigned to an order.</p>
            </div>
            <span className="serial-record-count">
              {data.length.toLocaleString("en-IN")}{" "}
              {data.length === 1 ? "ORDER" : "ORDERS"}
            </span>
          </header>

          {data.length > 0 ? (
            <div className="serial-table-shell">
              <Table className="serial-table">
                <thead>
                  <tr>
                    <th scope="col">Order ID</th>
                    <th scope="col">Status</th>
                    <th scope="col">Approval date</th>
                    <th scope="col">Items</th>
                    <th scope="col">Serial numbers</th>
                    <th scope="col">Vehicle</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, rowIndex) => {
                    const items = row.updatedQuantity || [];

                    return (
                      <tr key={row.orderid || rowIndex}>
                        <td data-label="Order ID">
                          <span className="serial-order-id">{row.orderid || "—"}</span>
                        </td>
                        <td data-label="Status">
                          <span className="serial-status">{row.status || "—"}</span>
                        </td>
                        <td data-label="Approval date">
                          <span className="serial-date">{row.ApprovalDate || "—"}</span>
                        </td>
                        <td data-label="Items" className="serial-items-cell">
                          <div className="serial-items">
                            {items.map((item, index) => (
                              <article
                                className="serial-item"
                                key={item._id || index}
                              >
                                <span className="serial-item-copy">
                                  <strong title={item.title || ""}>
                                    {item.title || "Untitled item"}
                                  </strong>
                                  <span className="serial-item-meta">
                                    SKU <code>{item.sku || "—"}</code>
                                    <span aria-hidden="true">·</span>
                                    {item.Medium || "—"}
                                  </span>
                                </span>
                                <span className="serial-quantity">
                                  {item.approvedquantity ?? 0}
                                </span>
                              </article>
                            ))}
                          </div>
                        </td>
                        <td data-label="Serial numbers">
                          <Button
                            type="button"
                            className="serial-view-button"
                            onClick={() => handleButtonClick(row)}
                            disabled={showData && selectedOrderId === row.orderid}
                            aria-label={"View serial numbers for order " + row.orderid}
                          >
                            View serials
                          </Button>
                        </td>
                        <td data-label="Vehicle">
                          <input
                            className="serial-vehicle-input"
                            type="text"
                            value={userInputs[row.orderid] || ""}
                            onChange={(e) => handleUserInputChange(e, row.orderid)}
                            placeholder="Enter vehicle"
                            aria-label={"Vehicle for order " + row.orderid}
                          />
                        </td>
                        <td data-label="Action">
                          <Button
                            type="button"
                            className="serial-update-button"
                            onClick={() => handleUpdateVehicle(row.orderid)}
                          >
                            Update
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="serial-empty-state">
              <span className="serial-empty-icon" aria-hidden="true">SN</span>
              <strong>No orders to display</strong>
              <span>Approved orders will appear here when they are available.</span>
            </div>
          )}

          {data.length > 0 && (
            <footer className="serial-panel-footer">
              Showing {data.length.toLocaleString("en-IN")}{" "}
              {data.length === 1 ? "order" : "orders"}
            </footer>
          )}
        </section>
      </div>

      {showData && (
        <div className="serial-modal-backdrop">
          <section
            className="serial-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="serial-dialog-title"
          >
            <header className="serial-dialog-header">
              <div>
                <p className="serial-section-eyebrow">Order {selectedOrderId}</p>
                <h2 id="serial-dialog-title">Serial number details</h2>
                <p>{record.length} batch {record.length === 1 ? "line" : "lines"}</p>
              </div>
              <Button
                type="button"
                className="serial-close-button"
                onClick={handleClose}
                aria-label="Close serial number details"
              >
                <span aria-hidden="true">×</span>
              </Button>
            </header>

            <div className="serial-dialog-body">
              <Table className="serial-detail-table">
                <thead>
                  <tr>
                    <th scope="col">Batch ID</th>
                    <th scope="col">Title</th>
                    <th scope="col">Serial number</th>
                  </tr>
                </thead>
                <tbody>
                  {record.map((row, rowIndex) =>
                    Array.from(Array(row.approvedquantity), (_, serialIndex) => (
                      <tr key={rowIndex + "-" + serialIndex}>
                        <td data-label="Batch ID">
                          <code className="serial-batch-id">{row.batchid || "—"}</code>
                        </td>
                        <td data-label="Title">{row.title || "—"}</td>
                        <td data-label="Serial number">
                          <code className="serial-number-code">
                            {row.batchid}-{serialIndex + 1}
                          </code>
                        </td>
                      </tr>
                    )),
                  )}
                </tbody>
              </Table>
            </div>
          </section>
        </div>
      )}
    </main>
  );
};

export default SerialNumber;
